<div [ngSwitch]="carregando">

    <!-- 🔄 SPINNER -->
    <div *ngSwitchCase="true" class="d-flex justify-content-center p-4">
        <mat-spinner diameter="50"></mat-spinner>
    </div>

    <!-- 📄 TABELA -->
    <div *ngSwitchCase="false">

        <div mat-dialog-title class="d-flex justify-content-center">
            <h5>Adicionar categorias ao Anexo selecionado.</h5>
        </div>

        <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Filtrar</mat-label>
            <input matInput [formControl]="filtroControl" placeholder="Digite para filtrar">
        </mat-form-field>

        <table style="width: 100%;" mat-table [dataSource]="TodasCategorias" class="mat-elevation-2">

            <!-- Nome -->
            <ng-container class="w-20" matColumnDef="nome">
                <th mat-header-cell *matHeaderCellDef> Nome </th>
                <td mat-cell *matCellDef="let element"> {{ element.Nome }} </td>
            </ng-container>

            <!-- NCM -->
            <ng-container class="w-10" matColumnDef="ncm">
                <th mat-header-cell *matHeaderCellDef> NCM </th>
                <td mat-cell *matCellDef="let element"> {{ element.Ncm }} </td>
            </ng-container>

            <!-- CEST -->
            <ng-container class="w-10" matColumnDef="cest">
                <th mat-header-cell *matHeaderCellDef> CEST </th>
                <td mat-cell *matCellDef="let element"> {{ element.Cest }} </td>
            </ng-container>

            <!-- Natureza Receita -->
            <ng-container class="w-10" matColumnDef="naturezaReceita">
                <th mat-header-cell *matHeaderCellDef> Natureza da Receita </th>
                <td mat-cell *matCellDef="let element"> {{ element.NaturezaReceita }} </td>
            </ng-container>
            <ng-container matColumnDef="button">
                <th mat-header-cell *matHeaderCellDef>
                    <div class="d-flex justify-content-end">
                    </div>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div class="d-flex justify-content-end">
                        <button mat-raised-button color="Sugestao" (click)="AdicionarAnexo(element)">Adicionar
                            Categoria</button>
                    </div>
                </td>
            </ng-container>

            <!-- Header + Rows -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

    </div>
    <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 100]" showFirstLastButtons>
    </mat-paginator>
</div>

<mat-dialog-actions align="end">
    <button mat-raised-button color="warn" mat-dialog-close>Fechar</button>
</mat-dialog-actions>